import { createGlobalStyle } from "styled-components";

import {
  Mulish400Woff,
  Mulish400Woff2,
  Mulish600Woff,
  Mulish600Woff2,
  Mulish700Woff,
  Mulish700Woff2,
  Inter400Woff,
  Inter400Woff2,
  Inter600Woff,
  Inter600Woff2,
  Inter700Woff,
  Inter700Woff2,
  RUIIconWebFontSVG as FontSvg,
  RUIIconWebFontTTF as FontTtf,
  RUIIconWebFontWOFF as FontWoff,
} from "./assets";

export const GlobalFontOverrides = createGlobalStyle`
  @font-face {
      font-family: 'Mulish';
      src:
      url("${Mulish400Woff}") format("woff"),
      url("${Mulish400Woff2}") format("woff2");
      font-display: swap;
      font-weight: 400;
      font-style: normal;
  }
  @font-face {
      font-family: 'Mulish';
      src:
      url("${Mulish400Woff}") format("woff"),
      url("${Mulish400Woff2}") format("woff2");
      font-display: swap;
      font-weight: normal;
      font-style: normal;
  }
  @font-face {
      font-family: 'Mulish';
      src:
      url("${Mulish600Woff}") format("woff"),
      url("${Mulish600Woff2}") format("woff2");  
      font-display: swap;
      font-weight: 600;
      font-style: normal;
  }
  @font-face {
      font-family: 'Mulish';
      src:
      url("${Mulish700Woff}") format("woff"),
      url("${Mulish700Woff2}") format("woff2");
      font-display: swap;
      font-weight: 700;
      font-style: normal;
  }
  @font-face {
    font-family: 'Inter';
    src:
    url("${Inter400Woff2}") format("woff2"),
    url("${Inter400Woff}") format("woff");
    font-display: swap;
    font-weight: 400;
    font-style: normal;
}
@font-face {
    font-family: 'Inter';
    src:
    url("${Inter400Woff2}") format("woff2"),
    url("${Inter400Woff}") format("woff");
    font-display: swap;
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'Inter';
    src:
    url("${Inter600Woff2}") format("woff2"),
    url("${Inter600Woff}") format("woff");  
    font-display: swap;
    font-weight: 600;
    font-style: normal;
}
@font-face {
    font-family: 'Inter';
    src:
    url("${Inter700Woff2}") format("woff2"),
    url("${Inter700Woff}") format("woff");
    font-display: swap;
    font-weight: 700;
    font-style: normal;
}
  @font-face {
    font-family: 'rui-icon';
    src:
      url("${FontWoff}") format("woff"),
      url("${FontTtf}") format("truetype"),
      url("${FontSvg}#rui-icon") format("svg");
    font-weight: normal;
    font-style: normal;
  }
  html body {
      font-family: 'Mulish', 'Inter', sans-serif;
      font-weight: normal;
  }
`;
